import { Component } from '@angular/core';

@Component({
  selector: 'app-project-email',
  templateUrl: './project-email.component.html',
  styleUrl: './project-email.component.scss'
})
export class ProjectEmailComponent {}
